<template>
  <div>
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="24">
        <el-col :span="6">
          <el-input placeholder="请输入姓名或手机号" v-model="queryInfo.cdit" clearable @clear="queryCardList"></el-input>
        </el-col>
        <el-col :span="3">
          <el-button type="success" icon="el-icon-search"  @click="queryCardList">搜索</el-button>
        </el-col>
        <el-col :span="6">
          <el-radio-group v-model="queryInfo.status"  @change="queryCardList">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button :label="1">正常</el-radio-button>
            <el-radio-button :label="0">删除</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>

      <!-- 用户列表区域 -->
      <el-table :data="tableData" stripe>
        <el-table-column prop="product_introduce" v-if="hide"></el-table-column>
        <el-table-column prop="company_introduce" v-if="hide"></el-table-column>
        <el-table-column prop="id" v-if="hide"></el-table-column>
        <el-table-column type="index" label="序号" min-width="80"></el-table-column>
        <el-table-column label="姓名" prop="name" min-width="100"></el-table-column>
        <el-table-column label="手机号" prop="phoneno" min-width="125"></el-table-column>
        <el-table-column label="电子邮箱" prop="email" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="联系地址" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>
              <span>{{scope.row.a_province_name}}</span>
              <span>{{scope.row.a_city_name}}</span>
              <span>{{scope.row.a_area_name}}</span>
            </div>
            <div>
              <span>{{scope.row.a_address}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="公司信息" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{scope.row.company_name}}</div>
            <div>{{scope.row.position_name}}</div>
            <div>{{scope.row.company_industry_name}}</div>
          </template>
        </el-table-column>
        <el-table-column label="主账号" min-width="175" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button type="text" @click="specQuery(scope.row.user_phoneno)">
              <div style="text-align: left;line-height: 20px;">{{scope.row.user_name}}</div>
              <div style="text-align: left;line-height: 20px;">{{scope.row.user_phoneno}}</div>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="80">
          <template slot-scope="scope">
            <span :style="scope.row.status == '正常'?'color:#6FC334':'color:#EB5753'">{{scope.row.status}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="175">
          <template slot-scope="scope">
            <el-button-group>
              <el-button size="medium" type="warning" :disabled="scope.row.status == '删除' ? true :false" @click="showEditDialog(scope.row)">修改</el-button>
              <el-button size="medium" type="danger" :disabled="scope.row.status == '删除' ? true :false" @click="removeCardById(scope.row.id)">删除</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <div style="text-align: right">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.page_ix" :page-size="queryInfo.page_size" layout="prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 添加用户的对话框 -->
    <el-dialog :title="formTitle" :visible.sync="dialogFormVisible" width="50%" @close="addDialogClosed">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="基本信息" name="first">
          <!-- 内容主体区域 -->
          <el-form :model="cardForm" :rules="cardFormRules" ref="cardForm" label-width="70px">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="cardForm.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phoneno">
              <el-input v-model="cardForm.phoneno"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="cardForm.email"></el-input>
            </el-form-item>
            <el-form-item label="联系地址" prop="a_address">
              <el-input v-model="cardForm.a_address"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="公司信息" name="second">
          <!-- 内容主体区域 -->
          <el-form :model="cardForm" :rules="cardFormRules" ref="cardForm" label-width="70px">
            <el-form-item label="公司名称" prop="company_name">
              <el-input v-model="cardForm.company_name"></el-input>
            </el-form-item>
            <el-form-item label="职位" prop="position_name">
              <el-input v-model="cardForm.position_name"></el-input>
            </el-form-item>
            <el-form-item label="所属行业" prop="company_industry_fullname">
              <el-input v-model="cardForm.company_industry_fullname"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="公司/业务介绍" name="third">
          <!-- 内容主体区域 -->
          <el-form :model="cardForm" :rules="cardFormRules" ref="cardForm" label-width="70px">
            <el-form-item label="公司介绍" prop="company_introduce">
              <!-- 富文本编辑器 -->
              <quill-editor v-model="cardForm.company_introduce"></quill-editor>
            </el-form-item>
            <el-form-item label="业务介绍" prop="product_introduce">
              <!-- 富文本编辑器 -->
              <quill-editor v-model="cardForm.product_introduce"></quill-editor>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('cardForm',add_edit)">保存设置</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    // 验证手机号的规则
    var checkMobile = (rule, value, cb) => {
      // 验证手机号的正则表达式
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/

      if (regMobile.test(value)) {
        return cb()
      }

      cb(new Error('请输入合法的手机号'))
    }

    return {
      hide: false,
      activeName: 'first',
      type: '',
      formTitle: '',
      add_edit: '',
      // 获取用户列表的参数对象
      queryInfo: {
        status: '',
        cdit: '',
        // 当前的页数
        page_ix: 1,
        // 当前每页显示多少条数据
        page_size: 10
      },
      tableData: [],
      total: 0, // 分页总数
      // 控制添加用户对话框的显示与隐藏
      dialogFormVisible: false,
      // 用户的表单数据
      cardForm: {
        vcard_id: '', // ID（可选，>0-编辑，无-新增）
        theme_id: '',
        share_id: '',
        phoneno: '',
        name: '',
        company_name: '',
        department_name: '',
        position_name: '',
        company_industry_fullname: '',
        email: '',
        a_address: '',
        company_introduce: '',
        product_introduce: ''
      },
      // 添加表单的验证规则对象
      cardFormRules: {
        name: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        phoneno: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.specQuery(this.$route.query.phone)
  },
  methods: {
    specQuery(phone = '') {
      this.queryInfo.cdit = phone
      this.queryCardList()
    },
    async queryCardList() {
      this.$axios.post('/admin/Vcard/queryVcard', this.queryInfo).then(res => {
        if (res.data.rst == 0) {
          this.tableData = res.data.data.data
          this.total = res.data.data.total
          this.tableData.forEach(e => {
            let std = e.status == '1' ? '正常' : '删除'
            e.status = std
          })
        } else {
          this.alertError(res.data.msg)
        }
      }).catch(err => {
        console.error('错误：', err)
      })
    },
    // 监听 page_size 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.page_size = newSize
      this.queryCardList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      // console.log(newPage)
      this.queryInfo.page_ix = newPage
      this.queryCardList()
    },
    // 监听用户对话框的关闭事件
    addDialogClosed() {
      this.$refs.cardForm.resetFields()
    },
    // 展示编辑用户的对话框
    showEditDialog(row) {
      this.formTitle = '名片信息'
      this.add_edit = 'edit'
      this.dialogFormVisible = true
      let std = row.status == '正常' ? 1 : 9
      Object.assign(this.cardForm, row)
      this.cardForm.status = std
    },
    // 提交表单
    submitForm(formName, type) {
      // // 开启登录加载动画
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (type == 'edit') {
            this.cardForm.status == '正常' ? 1 : 9
            let editparams = {
              vcard_id: this.cardForm.id, // ID（可选，>0-编辑，无-新增）
              theme_id: this.cardForm.theme_id,
              share_id: this.cardForm.share_id,
              phoneno: this.cardForm.phoneno,
              name: this.cardForm.name,
              company_name: this.cardForm.company_name,
              department_name: this.cardForm.department_name,
              position_name: this.cardForm.position_name,
              company_industry_fullname: this.cardForm.company_industry_fullname,
              email: this.cardForm.email,
              a_address: this.cardForm.a_address,
              company_introduce: this.cardForm.company_introduce,
              product_introduce: this.cardForm.product_introduce
            }
            console.log('this.cardForm', this.cardForm)
            this.$axios.post('/admin/Vcard/saveVcard', editparams).then(res => {
              if (res.data.rst == 0) {
                this.alertSuccess(res.data.msg)
                this.queryCardList()
                this.dialogFormVisible = false
              } else {
                this.alertError(res.data.msg)
              }
            }).catch(err => {
              console.error('错误：', err)
            })
          }
        } else {
          return false
        }
      })
    },
    // 根据Id删除对应的用户信息
    async removeCardById(id) {
      // 弹框询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将删除所选内容, 是否继续?',
        '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)

      // 如果用户确认删除，则返回值为字符串 confirm
      // 如果用户取消了删除，则返回值为字符串 cancel
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      let editparams = {
        vcard_id: id
      }
      this.$axios.post('/admin/Vcard/removeVcard', editparams).then(res => {
        if (res.data.rst == 0) {
          this.alertSuccess(res.data.msg)
          this.queryCardList()
        } else {
          this.alertError(res.data.msg)
        }
      }).catch(err => {
        console.error('错误：', err)
      })
    },
    // 名片跳转
    cardRout(phone) {
      this.$router.push({ name: 'card', query: { phone: phone } })
    },
    // 成功弹窗
    alertSuccess(msg) {
      this.$message.success({
        showClose: true,
        duration: 1000,
        message: msg,
        type: 'success'
      })
    },
    // 错误消息
    alertError(msg) {
      this.$message.error({
        duration: 1000,
        showClose: true,
        message: msg,
        type: 'error'
      })
    }
  }

}
</script>

<style lang="less" scoped>

</style>
